import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const Container = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium};
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    ${BaseStyle.Mixins.fontStyles.ui['12m']};
    color: ${({ theme }) => theme.Text.secondary};
    text-transform: uppercase;
`;

export const SelectContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium};
    display: flex;
    flex-direction: column;
`;
